module.exports = __webpack_public_path__ + "static/media/dashboard.dc5fa52d.svg";